import { IonCard, IonCardHeader, IonCardTitle, IonLabel } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { Machine } from '../../../api/graphql/generated';
import { useBeaconRouter } from '../../../route/route.hooks';
import { useGetMachineMaintenanceWindowText } from '../machine-maintenance';

interface MachineMaintenanceCardProps {
  machine?: Machine;
}

const MachineMaintenanceCard = (
  props: MachineMaintenanceCardProps
): ReactElement => {
  const { machine } = props;

  const { i18n } = useTranslation();
  const { builder } = useBeaconRouter();
  const maintenanceWindowLabel = useGetMachineMaintenanceWindowText(machine);

  let updatesStatus = i18n.t('common:none');
  const updatesPending =
    (machine?.state?.maintenance?.updates?.length ?? 0) > 0;
  if (updatesPending) {
    if (machine?.state?.maintenance?.reboot) {
      updatesStatus = i18n.t('common:maintenance_window_reboot_required');
    } else {
      updatesStatus = i18n.t('common:maintenance_window_updates_pending');
    }
  }

  return (
    <IonCard
      className="machine-card-container"
      routerLink={
        machine?.teamId && machine?.id
          ? builder.getMachineMaintenanceRoute(machine?.teamId, machine?.id)
          : undefined
      }
    >
      <IonCardHeader>
        <IonCardTitle>{i18n.t('common:maintenance_window')}</IonCardTitle>
      </IonCardHeader>
      <div className="machine-card-info-grid">
        <IonLabel className="machine-card-info-grid-label" color="medium">
          <p>{i18n.t('common:maintenance_window_short')}</p>
        </IonLabel>
        <IonLabel className="machine-card-info-grid-value" color="medium">
          <p>{maintenanceWindowLabel}</p>
        </IonLabel>
        <IonLabel className="machine-card-info-grid-label" color="medium">
          <p>{i18n.t('common:maintenance_window_updates')}</p>
        </IonLabel>
        <IonLabel className="machine-card-info-grid-value" color="medium">
          <p>{updatesStatus}</p>
        </IonLabel>
      </div>
    </IonCard>
  );
};

export { MachineMaintenanceCard };
